<ng-container *ngIf="isLoading then ShowLoading else ShowForm">
</ng-container>
<ng-template #ShowLoading>
    <div fxLayout="column" style="height: 90vh;" fxLayoutAlign="center center">
      <label>Παρακαλούμε περιμένετε όσο φορτώνουμε την αίτηση...</label>
        <app-loading></app-loading>
    </div>
</ng-template>

<ng-template #ShowForm>
    <div fxLayout="column" fxFlex="100" style="background-color: white;" id="form-main-container">
        <div fxLayout="row" ngStyle.gt-lg="width:65%;" ngStyle.lg="width:65%;" ngStyle.lt-lg="width:100%;"
             style="margin-left: auto; margin-right: auto; padding-bottom: 20px;">
            <div fxFlex="100" fxLayout="column"
                 ngStyle.gt-lg="padding:50px;" ngStyle.lg="padding:50px;" ngStyle.lt-lg="padding:0;"
                 style="background-color: white; overflow-y: auto; overflow-x: hidden;  padding-bottom: 50px;"
                 [fxLayoutGap]="form.settings.gapRow">

<!--#region language row-->
                <div fxLayout="row" style="width: 100%; cursor:pointer; margin-bottom: 15px; padding-right: 15px;" [fxLayoutAlign]="form.settings.language.position" *ngIf="form.settings.language.multi">
                    <div fxLayoutGap="5px">
                        <span  *ngFor="let language of form.settings.language.languages" [ngStyle]="language.id === form.settings.language.preview && {'font-weight': 'bold'}" (click)="setPreviewLanguage(language.id)">{{language.value}}</span>
                    </div>
                </div>
<!--#endregion-->

                <div *ngFor="let row of form.rows" fxLayout='row'>
                    <div class="container" *ngIf="displayRow(row)" fxFlex="100">

                        <div fxLayout="column" fxLayoutGap="15px;" fxFlex="100">

                            <div fxLayout="row" [ngStyle]="{'margin-bottom': row.title.margin}">
                                <label [style.color]="row.title.color">{{displayRowName(row)}}</label>
                            </div>

                            <div fxLayout.gt-md="row" fxLayout.lt-md="column" [fxLayoutGap]='form.settings.gap'
                                >
                                <div
                                        *ngFor="let member of row.members; let i=index" class="internal-container"
                                        fxFlex.lt-md="100"
                                        [fxFlex.gt-md]="calculateFlex(row.members.length)">
                                    <div>

                                        <div *ngIf="!member.isHidden || mode==='author'">
                                            <div fxLayout="column" fxFlex="100" style="position: relative;">

                                                <!--#region Input Text-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'text'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden">
                                                        <label
                                                            class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">
                                                            {{displayFieldName(member)}}
                                                        </label>&nbsp;
                                                        <label
                                                            *ngIf="member.isRequired">*</label></div>
                                                    <mat-form-field fxFlex="100" class="full-width no-padding"
                                                                    [ngClass]="{'mat-form-field-invalid' : shouldDisplayEmptyWarning(member)}"
                                                                    appearance="outline">
                                                        <input style="width: 100%;" matInput [(ngModel)]="member.value"
                                                               [placeholder]="displayPlaceHolder(member)">
                                                    </mat-form-field>
                                                </template>
                                                <!--#endregion-->
                                                <!--#region Date Text-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'date'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden"><label
                                                            class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                            *ngIf="member.isRequired">*</label></div>
                                                    <mat-form-field fxFlex="100" class="full-width no-padding"
                                                                    [ngClass]="{'mat-form-field-invalid' : shouldDisplayEmptyWarning(member)}"
                                                                    appearance="outline">
                                                        <input style="width: 100%;" matInput [matDatepicker]="picker"
                                                               [placeholder]="displayPlaceHolder(member)"
                                                               [(ngModel)]="member.value">
                                                        <mat-datepicker-toggle matSuffix
                                                                               [for]="picker"></mat-datepicker-toggle>
                                                        <mat-datepicker #picker></mat-datepicker>
                                                    </mat-form-field>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region Textarea-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'textarea'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden"><label
                                                            class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                            *ngIf="member.isRequired">*</label></div>
                                                    <mat-form-field fxFlex="100" appearance="outline"
                                                                    [ngClass]="{'mat-form-field-invalid' : shouldDisplayEmptyWarning(member)}"
                                                                    style="width: 100%;" class="full-width no-padding">
                                            <textarea style="width: 100%;" matInput
                                                      [placeholder]="displayPlaceHolder(member)"
                                                      [(ngModel)]="member.value"></textarea>
                                                    </mat-form-field>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region Dropdown-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'dropdown'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden"><label
                                                            class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                            *ngIf="member.isRequired">*</label></div>
                                                    <mat-form-field fxFlex="100" appearance="outline"
                                                                    [ngClass]="{'mat-form-field-invalid' : shouldDisplayEmptyWarning(member)}"
                                                                    style="width:100%;" class="full-width no-padding">
                                                        <mat-select [(ngModel)]="member.value"
                                                                    [placeholder]="displayPlaceHolder(member)"
                                                                    [compareWith]="compareOptions" fxFlex="100">
                                                            <mat-option *ngFor="let option of member.options"
                                                                        [value]="option" style="font-family: 'Century Gothic', sans-serif !important;">{{option.value}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region Radio-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'radio'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden"><label
                                                            class="control-title"
                                                            style="margin-bottom: 15px !important;" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                            *ngIf="member.isRequired">*</label></div>
                                                    <mat-radio-group *ngIf="member.options.length > 0" fxFlex="100"
                                                                     fxLayoutGap="15px"
                                                                     (change)="radioChanged($event, member)">
                                                        <mat-radio-button *ngFor="let option of member.options"
                                                                          [value]="option"
                                                                          class="radio"
                                                                          [checked]="member.value.id === option.id">{{option.value}}</mat-radio-button>
                                                    </mat-radio-group>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region Image-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'image'"
                                                        fxLayout="column">
                                                    <img *ngIf="member.value" [src]="member.value" alt="temp"/>
                                                    <label *ngIf="!member.value">Προσθέστε το σύνδεσμο της εικόνας από
                                                        τη μορφοποίση του πεδίου</label>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region File-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'file'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden">
                                                        <label
                                                            class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                            *ngIf="member.isRequired">*</label></div>

                                                    <div fxLayout="row" fxLayoutGap="5px">
                                                    <button mat-raised-button (click)="inputField.click();">Επιλέξτε
                                                        αρχείο
                                                    </button>
                                                    <input type="file" #inputField style="display:none" (change)="onFileSelected($event, member)">
                                                      <mat-icon *ngIf="member.hiddenValue && mode === 'new'" style="color: green;">done</mat-icon>
                                                        <button *ngIf="member.hiddenValue && mode !== 'new'" mat-icon-button (click)="displayFile(member.hiddenValue)" matTooltip="Προβολή επισυναπτόμενου"><mat-icon>visibility</mat-icon></button>
                                                    </div>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region Label-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'label'"
                                                        fxLayout="column">
                                                    <div fxFlex="100" *ngIf="member.value">
                                                        <app-extreme-editor fxFlex="100" [value]="displayValueLabel(member)"
                                                                            [isEdit]="false"></app-extreme-editor>
                                                    </div>
                                                    <div fxFlex="100" fxLayout="row" *ngIf="!member.value"
                                                         fxLayoutAlign="start center">
                                                    </div>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region conditional-selector-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'conditional-selector'"
                                                        fxLayout="column">
                                                    <div fxLayout="row" *ngIf="!member.isLabelHidden"><label
                                                            class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                            *ngIf="member.isRequired">*</label></div>
                                                    <mat-form-field fxFlex="100" appearance="outline"
                                                                    [ngClass]="{'mat-form-field-invalid' : shouldDisplayEmptyWarning(member)}"
                                                                    style="width:100%;" class="full-width no-padding">
                                                        <mat-select (selectionChange)="setCondition($event)"
                                                                    [(ngModel)]="member.value" fxFlex="100"
                                                                    [compareWith]="compareOptions"
                                                                    [placeholder]="displayPlaceHolder(member)">
                                                            <mat-option *ngFor="let option of member.options"
                                                                        [value]="option" style="font-family: 'Century Gothic', sans-serif !important;">{{option.value}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </template>
                                                <!--#endregion-->

                                                <!--#region Checkbox-->
                                                <template
                                                        *ngIf="member.hasOwnProperty('controls') && member.controls.length > 0 && member.controls[0].type === 'checkbox'"
                                                        fxLayout="column">
                                                    <div fxFlex="100" fxLayoutAlign="start center">
                                                        <mat-checkbox [checked]="member.value ? true: false"
                                                                      (change)="checkedChange($event, member)"></mat-checkbox>
                                                        &nbsp;
                                                        <div fxLayout="row" *ngIf="!member.isLabelHidden"><label
                                                                class="control-title" [style.color]="member.labelColor ? member.labelColor : '#00000000'">{{displayFieldName(member)}}</label>&nbsp;<label
                                                                *ngIf="member.isRequired">*</label></div>
                                                    </div>
                                                </template>
                                                <!--#endregion-->
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>


                <div #endForm style="display: hidden;"></div>

                <div *ngIf="previewFiles.length > 0" fxLayout="column" fxFlex="100" style="padding: 15px;" fxLayoutGap="15px;">
                    <div fxLayout="row">
                        <h2>Περιοχή μεταφορτωμένων αρχείων</h2>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                    <div *ngFor="let file of previewFiles" style="cursor: pointer; border: 1px solid lightgray;  border-radius: 10px; padding: 10px;" (click)="fetchFile(file)" fxLayoutAlign="center center">
                        {{file.name}}
                    </div>
                    </div>
                </div>

                <div *ngIf="twoFactor.display" fxLayout="row" style="padding: 15px;">
                    <div fxLayout="column" fxLayoutGap="15px;" fxFlex="100" fxLayoutAlign="center center">
                        <div fxLayout="row" style="width: 100%">
                            {{twoFactor.message}}
                        </div>
                        <div fxLayout="row" style="width: 100%" fxLayoutGap="5px;" fxLayoutAlign="start center">
                            <mat-form-field>
                                <input matInput [(ngModel)]="this.twoFactor.value" type="text" pattern="\d*" maxlength="6" />
                            </mat-form-field>

                            <button *ngIf="!isTFADisabled()" [disabled]="isFinalizing" [class.spinner]="isFinalizing" mat-icon-button (click)="sendTFA()"><mat-icon style="color: var(--secondaryBlue);">send</mat-icon></button>
                            <button *ngIf="isTFADisabled()"  mat-icon-button><mat-icon style="color: lightgray">send</mat-icon></button>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" fxFlex="100" fxLayoutAlign="center center">
                    <button *ngIf="mode === 'new'" mat-raised-button (click)="submit()" [class.spinner]="isSubmitting"
                            [disabled]="isSubmitting || twoFactor.display">Υποβολή
                    </button>

                    <button *ngIf="mode === 'reapply'" mat-raised-button (click)="reapply()" [class.spinner]="isSubmitting"
                            [disabled]="isSubmitting || twoFactor.display">Υποβολή
                    </button>

                    <button *ngIf="mode === 'author'" mat-raised-button (click)="update()"
                            [class.spinner]="isSubmitting" [disabled]="isSubmitting">Ενημέρωση
                    </button>

<!--                  <button *ngIf="mode === 'author'" mat-raised-button (click)="exportPdf()" [class.spinner]="isExporting" [disabled]="isExporting">Εξαγωγή σε PDF-->
<!--                    </button>-->
                </div>


            </div>

        </div>
    </div>
</ng-template>
